import { useProductosBom } from "../contexto/provider/ProductosBomContext.js";

export function useProductosInsumos() {
  const { productosBom, loading, cargarProductosBom } = useProductosBom();
  return { productosBom, loading, cargarProductosBom };
}